import { createGlobalStyle } from 'styled-components';
import { breakpoint } from '../../mixins/breakpoints';

const ContentPage = createGlobalStyle`
  .content-page {
    &--article{
      ${breakpoint('large')}{
        margin-top: 4rem;
      }
    }
    .subnav{
        &--mobile{
            ${breakpoint('medium')} {
            display: none;  }
        }
        &--desktop{
            display: none;
            ${breakpoint('medium')} {
            display: block;  }
        }
    }
  }
`;

export default ContentPage;
